import React from 'react';
import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import FormLanguageSelector from '../../../../components/formik-components/FormLanguageSelector';
import { formikFormShape } from '../../../../components/prop-types';
import { DropdownComponent } from '../../../../components/prime-formik';

const messages = defineMessages({
  searchingLabel: {
    id: 'actions.select',
    defaultMessage: '- Select -',
  },
  printerFriendLy: {
    id: 'preferences.prefer-printer-friendly-reports',
    defaultMessage: 'I prefer printer friendly reports',
  },
  submit: {
    id: 'assessment.matchingResults',
    defaultMessage: 'Matching Results',
  },
});

const CustomJobMatchingForm = ({
  jobProfiles,
  selectJob,
  languageList,
  selectLocale,
  printerFriendly,
  changePrinterFriendly,
  readyToSubmit,
}) => {
  const { formatMessage } = useIntl();
  const { setFieldValue, isSubmitting } = useFormikContext();

  const searchingLabel = formatMessage(messages.searchingLabel);
  const submitLabel = formatMessage(messages.submit);

  const options = jobProfiles.map((jobProfile) => {
    return {
      value: jobProfile.id,
      label: jobProfile.name,
    };
  });

  return (
    <>
      <div className="p-grid">
        <div className="p-col">
          <div>
            <FormattedMessage tagName="label" id="assessment.jobMatching" defaultMessage="Job Matching" />
          </div>
          <Field
            filter
            className="width-full"
            component={DropdownComponent}
            options={options}
            placeholder={searchingLabel}
            name="jobProfileId"
            onChange={(event) => {
              setFieldValue('jobProfileId', event.target.value);
              selectJob(event.target.value);
            }}
          />
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <FormattedMessage id="attrs.locale" defaultMessage="Preferred Language" tagName="label" />
          <Field
            id="locale"
            name="locale"
            component={FormLanguageSelector}
            options={languageList}
            onChange={(event) => {
              setFieldValue('locale', event.value);
              selectLocale(event.value);
            }}
          />
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col">
          <Checkbox inputId="printerFriendly" checked={printerFriendly} onChange={changePrinterFriendly} />
          <FormattedMessage
            id="preferences.prefer-printer-friendly-reports"
            defaultMessage="I prefer printer friendly reports"
            tagName="label"
          >
            {(text) => <label htmlFor="printerFriendly">{text}</label>}
          </FormattedMessage>
        </div>
      </div>
      <div className="p-grid p-fluid p-justify-center">
        <div className="p-sm-12 p-md-8">
          <Button type="submit" disabled={isSubmitting || !readyToSubmit} label={submitLabel} />
        </div>
      </div>
    </>
  );
};

CustomJobMatchingForm.propTypes = {
  formProps: formikFormShape.isRequired,
  jobProfiles: PropTypes.arrayOf(PropTypes.any).isRequired,
  languageList: PropTypes.arrayOf(PropTypes.any).isRequired,
  jobSearching: PropTypes.bool.isRequired,
  printerFriendly: PropTypes.bool,
  readyToSubmit: PropTypes.bool.isRequired,
  searchJob: PropTypes.func.isRequired,
  selectJob: PropTypes.func.isRequired,
  selectLocale: PropTypes.func.isRequired,
  changePrinterFriendly: PropTypes.func.isRequired,
};

CustomJobMatchingForm.defaultProps = {
  printerFriendly: null,
};

export default CustomJobMatchingForm;
